import Rollbar from 'rollbar'
import isbot from 'isbot'

const IGNORED_MESSAGES = [
  /The play\(\) request was interrupted by a call to pause\(\)/,
  /^Script error\.?$/,
  /^(?=.*unknown)(?=.*SyntaxError).*$/
]

Rollbar.init({
  accessToken: '85411be3874b40b09b0938e9948cd37a',
  enabled: (window.rollbarEnvironment === 'production' || window.rollbarEnvironment === 'staging'),
  captureUncaught: true,
  captureUnhandledRejections: true,
  ignoredMessages: IGNORED_MESSAGES,
  payload: {
    environment: window.rollbarEnvironment,
    client: {
      javascript: {
        code_version: window.codeVersion
      }
    }
  },
  scrubFields: ['credit-card-number', 'expiration-month', 'expiration-year', 'cvv'],
  scrubTelemetryInputs: true,
  hostSafeList: [
    /envato-static/,
    /envato-staging/,
    /themeforest/,
    /codecanyon/,
    /videohive/,
    /audiojungle/,
    /3docean/,
    /photodune/,
    /graphicriver/
  ],
  checkIgnore: function (_isUncaught, _args, _payload) {
    if (window.navigator.userAgent) {
      const foundFF = window.navigator.userAgent.match(/ Firefox\/(\d+)/)
      if (foundFF) {
        // ignore Firefox version below 50 (released in 2016)
        return (+foundFF[1] < 50)
      }
      const foundCh = window.navigator.userAgent.match(/ Chrome\/(\d+)/)
      if (foundCh) {
        // ignore Chrome version below 49 (released in 2016)
        return (+foundCh[1] < 49)
      }
      const foundSaf = window.navigator.userAgent.match(/ Version\/(\d+).* Safari\//)
      if (foundSaf) {
        // ignore Safari version below 12
        return +foundSaf[1] < 12
      }
      if (isbot(window.navigator.userAgent)) {
        return true
      }
    }
    return false
  }
})
